import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { getGameStaticData } from '@gameday/utils/selectors/getGameStaticData';

const emptyPerson = {};

// Custom selector factory that won't invalidate unless the id has changed
// Requires person.id be in the return state object
const createPersonIdSelector = createSelectorCreator(defaultMemoize, ({ person: { id } = {} } = emptyPerson, { person: { id: previousId } = {} } = emptyPerson) => {
    return id === previousId;
});

const createPersonIdSelectorFactory = (selector) => createPersonIdSelector(selector, (result = emptyPerson) => result);

// selectors
const getIsLoading = (state) => state.loading?.isLoading;
const getLinescore = createSelector((state) => state.gumbo?.liveData?.linescore || {}, (linescore) => linescore);
const getBatter = (state) => getLinescore(state).offense?.batter;
const getInHole = createPersonIdSelectorFactory((state) => getLinescore(state).offense?.inHole);
const getOnDeck = createPersonIdSelectorFactory((state) => getLinescore(state).offense?.onDeck);
const getFirst = createPersonIdSelectorFactory((state) => getLinescore(state).offense?.first);
const getSecond = createPersonIdSelectorFactory((state) => getLinescore(state).offense?.second);
const getThird = createPersonIdSelectorFactory((state) => getLinescore(state).offense?.third);
const getPitcher = (state) => getLinescore(state).defense?.pitcher;
const getBalls = (state) => getLinescore(state).balls ?? 0;
const getStrikes = (state) => getLinescore(state).strikes ?? 0;
const getOuts = (state) => getLinescore(state).outs ?? 0;
const getAbstractGameCode = (state) => state?.gumbo?.gameData?.status?.abstractGameCode || '';
const getDeviceInteraction = (state) => state.config?.deviceInteraction;
const getPlayerDuelStats = (state) => state?.playerDuel;
const getLoadingPlayerDuelStats = (state) => state?.playerDuel?.isLoadingMatchupStats;

// reselect function
export const getPlayerDuelState = createSelector(
    [getIsLoading, getBatter, getInHole, getOnDeck, getFirst, getSecond, getThird, getPitcher, getBalls, getStrikes, getOuts, getAbstractGameCode, getGameStaticData, getDeviceInteraction, getPlayerDuelStats, getLoadingPlayerDuelStats],
    (isLoading, batter, inHole, onDeck, first, second, third, pitcher, balls, strikes, outs, abstractGameCode, gameStaticData, deviceInteraction, playerDuelStats, isLoadingPlayerDuelStats) => {
        return {
            isLoading,
            batter,
            inHole,
            onDeck,
            first,
            second,
            third,
            pitcher,
            balls,
            strikes,
            outs,
            abstractGameCode,
            probablePitchers: gameStaticData.probablePitchers,
            deviceInteraction,
            playerDuelStats,
            isLoadingPlayerDuelStats
        };
    }

);
